import type { IOrganization, Organization } from './organizations/organization';

export interface IAccess {
	id: string;
	organizations: IOrganization[];
}

export class Access implements IAccess {
	public id: string;
	public organizations: Organization[];
	public constructor({ id, organizations }: IAccess) {
		this.id = id;
		this.organizations = organizations;
	}
}
